var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDroplet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79999 11C6.27409 11.9122 5.9975 12.9467 5.99799 13.9996C5.99847 15.0525 6.27602 16.0867 6.80276 16.9984C7.32949 17.9101 8.08686 18.6671 8.99879 19.1934C9.91071 19.7197 10.9451 19.9968 11.998 19.9968C13.0509 19.9968 14.0853 19.7197 14.9972 19.1934C15.9091 18.6671 16.6665 17.9101 17.1932 16.9984C17.7199 16.0867 17.9975 15.0525 17.998 13.9996C17.9985 12.9467 17.7219 11.9122 17.196 11L11.999 3L6.79899 11H6.79999Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroplet);
export default __webpack_public_path__ + "static/media/Droplet.c85fc41a7c1a937b1b87e57b5c394968.svg";
export { ForwardRef as ReactComponent };